import React from "react";
import PropTypes from "prop-types";
import MLSSelector from "./MLSSelector";
import PeriodDropdown from "./PeriodDropdown";
import ViewTypesSelector from "./ViewTypesSelector";
import OfficesDropdown from "./OfficesDropdown";
import { terms } from "./../constants";

const TitleRow = (props) => {
    return (
        <div className="grid p-4">
            <div className='float-left'>
                <h2 className='text-truncate mb-0 helix-display-small'>
                    {terms.welcome.replace('[AGENT_NAME]', props.userInfo?.firstName || props.userInfo?.given_name)}
                </h2>
            </div>
            <div className="align-items-center float-right d-flex">
                <MLSSelector {...props} />
                <ViewTypesSelector />
                <OfficesDropdown />
                <PeriodDropdown />
            </div>
        </div>
    )
};

TitleRow.propTypes = {
    userInfo: PropTypes.object,
};

export default TitleRow;
